var map = {
	"./amex.png": 945,
	"./diners.png": 946,
	"./discover.png": 947,
	"./jcb.png": 948,
	"./maestro.png": 1172,
	"./mastercard.png": 949,
	"./stripe.png": 950,
	"./union.png": 951,
	"./unknown.png": 628,
	"./visa.png": 952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1171;